import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import CanvasFormInputValue from './CanvasFormInputValue';

function CanvasFormTextAreaValue({className, value, isSnapshotView = true}) {
	/* isSnapshotView is wrongly named, it actually allows proper conversion from text to HTML */
	return <StyledCanvasFormInputValue className={className} isSnapshotView={isSnapshotView} value={value} />;
}

const StyledCanvasFormInputValue = styled(CanvasFormInputValue)`
	/* Allow displaying new line breaks on the span component */
	span:first-of-type {
		white-space: pre-line;
	}
`;

CanvasFormTextAreaValue.propTypes = {
	className: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

CanvasFormTextAreaValue.defaultPropTypes = {
	className: 'canvas-form-text-area-value'
};

export default CanvasFormTextAreaValue;
